<template>
  <label class="ai-visibility-select">
    <span v-if="$slots.default" class="ai-visibility-select__label">
      <slot />
    </span>
    <span class="ai-visibility-select__control">
      <select
        :value="value"
        :disabled="disabled"
        :aria-label="ariaLabel"
        @change="$emit('input', $event.target.value)"
      >
        <option
          v-for="option in options"
          :key="option[valueKey]"
          :value="option[valueKey]"
        >
          {{ option[labelKey] }}
        </option>
      </select>
      <i class="material-icons">keyboard_arrow_down</i>
    </span>
  </label>
</template>

<script>
export default {
  name: 'AiVisibilitySelect',
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
    options: {
      type: Array,
      default () {
        return []
      },
    },
    labelKey: {
      type: String,
      default: 'label',
    },
    valueKey: {
      type: String,
      default: 'value',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    ariaLabel: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="scss" scoped>

.ai-visibility-select {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.ai-visibility-select__label {
  color: var(--v-mainColor3-base);
  font-size: 12px;
  font-weight: 700;
}

.ai-visibility-select__control {
  position: relative;
  display: inline-flex;
  min-width: 132px;
}

.ai-visibility-select select {
  font-family: "Mulish";
  width: 100%;
  height: 42px;
  appearance: none;
  border: 1px solid var(--v-gray13Color-base);
  border-radius: 6px;
  background: var(--v-cardBg-base);
  color: var(--v-blackColor-base);
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  padding: 0 36px 0 12px;
}

.ai-visibility-select select:disabled {
  cursor: default;
  opacity: 0.65;
}

.ai-visibility-select i {
  position: absolute;
  top: 50%;
  right: 9px;
  color: var(--v-link3Color-base);
  font-size: 22px;
  pointer-events: none;
  transform: translateY(-50%);
}
</style>
